/* eslint-disable */
// Count items in the multi-order table: what one unit is called (the product's sub-unit, e.g.
// "pax", else "pc") and what one weighs (the variant's minWeight, grams) - see
// MultiplePoContext productInfoById.

// The variant a table row is for - set on rows added from the dropdown, else on its cells.
export const getRowItemId = (row) => {
	if (row?.itemId) return row.itemId;
	const cell = Object.values(row || {}).find(
		(c) => c && typeof c === 'object' && c.itemId
	);
	return cell?.itemId ?? null;
};

export const isCountItem = (info) => info?.unit === 'count';

export const countUnitLabel = (info, fallback = 'pc') =>
	(isCountItem(info) && info?.subUnitName) || fallback;

const fmt = (n) => Number(Math.round(Number(n) * 1000) / 1000);

// "34 g per pax" / "34 g per pc" - null when the variant has no minWeight.
export const minWeightText = (info) => {
	if (!isCountItem(info) || !info?.minWeight) return null;
	return `${fmt(info.minWeight)} g per ${countUnitLabel(info)}`;
};

// kg typed by the user -> whole count, using the variant's minWeight (grams per unit).
export const kgToCount = (kg, minWeight) => {
	const n = Number(kg);
	if (!minWeight || Number.isNaN(n)) return null;
	return Math.round((n * 1000) / minWeight);
};

export const countToKg = (count, minWeight) => {
	const n = Number(count);
	if (!minWeight || Number.isNaN(n)) return null;
	return fmt((n * minWeight) / 1000);
};
